import React from 'react';
import { RowHeaderTable } from '../../components';
import TablePaymentOrderGroups from '../../components/TablePaymentOrdersGroup';

const PaymentOrderGroups: React.FC = () => {
  return (
    <div className="container-body no-padding">
      <RowHeaderTable name="Ordens de Pagamento" />
      <TablePaymentOrderGroups />
    </div>
  );
};

export default PaymentOrderGroups;
